
        <div [innerHTML]="contentLabels.requestLoss"></div>
